/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Picture from '../picture'

// TODO Set the correct article ID here
const ARTICLE_ID = '206166254925'

function Grid(props) {
  return <div className='grid'>{props.children}</div>
}

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Ein Karikaturist zeichnet aus der Intensivstation</h1>
            <h2>
              Mit Farben und Papier hat unser Cartoonist Felix Schaad einen Tag
              bei schwer kranken Patienten in der Hirslanden-Klinik verbracht.
              Das Resultat? Eine ganz andere Sicht auf das Leid.
            </h2>
          </div>
        </div>
      </header>

      {/* }
      <div className='ui vertical segment' style={{ paddingTop: '1em' }}>
        <div className='ui container'>
          <div className='ta metainfo'>
            <div className='ta author'>Felix Schaad</div>
            <div className='ta updated'>Aktualisiert am 1. Februar 2022</div>
          </div>
        </div>
      </div>
  */}

      <div className='intro'>
        <img
          src={require('../../images/header.jpg')}
          className='ui fluid image'
        />
      </div>

      <div className='ui vertical segment'>
        <Grid>
          <Picture no={0} />
          <Picture src='1.gif' />
          <Picture src='2.gif' />
          <Picture src='3.gif' />
          <Picture no={4} className='double left' />
          <Picture src='5.gif' />
          <Picture no={6} />
          <Picture no={7} className='fourer left p7' />
          <Picture no={8} />
          <Picture no={9} />
          <Picture src='10.gif' />
          <Picture src='11.gif' />
          <Picture no={12} className='double left' />
          <Picture src='13.gif' />
          <Picture no={14} />
          <Picture no={15} />
          <Picture no={16} />
          <Picture src='17.gif' className='double right' />
          <Picture no={18} className='double left' />
          <Picture no={19} className='double right' />
          <Picture no={20} className='double left' />
          <Picture src='21.gif' className='double right' />
          <Picture src='22.gif' className='double left' />
          <Picture no={23} className='double right' />
        </Grid>

        <div style={{ clear: 'both' }} />
      </div>

      <Footer
        articleId={ARTICLE_ID}
        hidePortfolioTeaser
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen das Format der Comic-Reportage?'
        ]}
        credits={[
          ['Zeichnungen, Reportage', 'Felix Schaad'],
          ['Digitale Umsetzung, Animation', 'Mathias Lutz']
        ]}
      />
    </div>
  )
}
